import * as actionTypes from "../../constants/actionTypes";
import { handleDataStatus, initialDataStatus } from "./shared/dataStatus";
import { handle } from "redux-pack";
import { OFFER_TYPES } from "../../constants/offerTypes";

const status = (
  state = {
    phoneOffer: initialDataStatus,
    proposition: initialDataStatus,
    simOnly: initialDataStatus
  },
  action
) => {
  let offerType;
  if (action.type === actionTypes.LOAD_PHONE_OFFER_COUNT) {
    offerType = OFFER_TYPES.phoneOffer;
  } else if (action.type === actionTypes.LOAD_PROPOSITION_COUNT) {
    offerType = OFFER_TYPES.proposition;
  } else if (action.type === actionTypes.LOAD_SIM_ONLY_COUNT) {
    offerType = OFFER_TYPES.simOnly;
  }

  switch (action.type) {
    case actionTypes.LOAD_PHONE_OFFER_COUNT:
    case actionTypes.LOAD_PROPOSITION_COUNT:
    case actionTypes.LOAD_SIM_ONLY_COUNT:
      return {
        ...state,
        [offerType]: handleDataStatus(state[offerType], action)
      };
    case actionTypes.INVALIDATE_OFFER_TYPE_COUNTS:
    case actionTypes.INVALIDATE_PORTAL_STATIC_DATA:
      return {
        [OFFER_TYPES.phoneOffer]: {
          ...state[OFFER_TYPES.phoneOffer],
          didInvalidate: true
        },
        [OFFER_TYPES.proposition]: {
          ...state[OFFER_TYPES.proposition],
          didInvalidate: true
        },
        [OFFER_TYPES.simOnly]: {
          ...state[OFFER_TYPES.simOnly],
          didInvalidate: true
        }
      };
    default:
      return state;
  }
};

const offerTypeCounts = (
  state = {
    phoneOffer: null,
    proposition: null,
    simOnly: null
  },
  action
) => {
  switch (action.type) {
    case actionTypes.LOAD_PHONE_OFFER_COUNT:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            [OFFER_TYPES.phoneOffer]: action.payload.count
          })
        });
      } else {
        return state;
      }
    case actionTypes.LOAD_PROPOSITION_COUNT:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            [OFFER_TYPES.proposition]: action.payload.count
          })
        });
      } else {
        return state;
      }
    case actionTypes.LOAD_SIM_ONLY_COUNT:
      if (action.payload !== undefined) {
        return handle(state, action, {
          success: prevState => ({
            ...prevState,
            [OFFER_TYPES.simOnly]: action.payload.count
          })
        });
      } else {
        return state;
      }
    default:
      return state;
  }
};

export { offerTypeCounts, status };
